import { Component, computed, input } from '@angular/core';
import { DetailViewDto } from '@myarvato/modules/transport/models';
import { DataFieldComponent } from '@myarvato/shared/data-field';
import { TranslatePipe } from '@ngx-translate/core';
import { DayjsPipe } from '@myarvato/shared/pipelines';
import { AddressFieldComponent } from '@myarvato/shared/address-field';

@Component({
  selector: 'transport-parcel-details',
  imports: [DataFieldComponent, TranslatePipe, DayjsPipe, AddressFieldComponent],
  templateUrl: './details-meta.component.html',
  styleUrl: './details-meta.component.scss',
})
export class DetailsMetaComponent {
  // Inputs
  public readonly details = input.required<DetailViewDto>();

  // Change Detection
  protected readonly directionKey = computed(() => {
    const direction = this.details().shipmentDirection;
    if (!direction) {
      return '';
    }

    return 'pages.transport.detail-page.details.direction-' + direction;
  });

  protected readonly progressCombined = computed(() => {
    const details = this.details();

    let progress = details.progress;

    if (progress && details.severityDetailsDescription) {
      progress = `${progress} • ${details.severityDetailsDescription}`;
    }

    return progress;
  });

  protected readonly carrierCombined = computed(() => {
    const details = this.details();

    let carrier = details.carrierDescription;

    if (details.carrierServiceDescription) {
      carrier = `${carrier} • ${details.carrierServiceDescription}`;
    }

    return carrier;
  });
}
